import { defineAction } from '~/prix'
import residenceDeleteAction from './residenceDelete.action.json' with { type: 'json' }
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const residenceDeleteDefinition = defineAction({
  ...residenceDeleteAction,

  input: z.object({
    id: z.string().uuid(),
    updatedAt: dateOrIsoString().nullish(),
  }),
  output: z.object({}),
})

export default residenceDeleteDefinition
